import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DropdownCommon } from '../../common/DropdownCommon';
import { usePrepackagedPlans } from '../../../hooks/usePrepackagedPlans';
import { CUSTOM_PLAN_ID } from '../planSection/constants';

export const FilterByProp103Dropdown = () => {
  const { t } = useTranslation('quoting');
  const {
    plansPackaged,
    quoteSelected,
    onChangePrepackagedPlan,
    onChangeCustomPlan,
  } = usePrepackagedPlans();

  const matchingPrepackagedPlan = useMemo(
    () => plansPackaged
      .find((plan) => plan.DeductibleId === quoteSelected.deductibleId
        && plan.ReimbursementId === quoteSelected.reimbursementId
        && plan.PlanId === quoteSelected.selectedPlan),
    [plansPackaged, quoteSelected],
  );

  const options = useMemo(() => {
    let prepackagedPlans = plansPackaged.map((plan) => ({
      label: plan.Name,
      value: plan.Id,
    }));

    const customPlanOption = {
      label: t('prepackagedPlans.customPlanProp103'),
      value: CUSTOM_PLAN_ID,
    };
    prepackagedPlans = [...prepackagedPlans, customPlanOption];
    return prepackagedPlans;
  }, [plansPackaged, t]);

  const selectedOption = useMemo(
    () => options
      .find((option) => option.value
        === quoteSelected.selectedPlanPackaged),
    [options, quoteSelected.selectedPlanPackaged],
  );

  const onChange = (option) => {
    if (option.value === CUSTOM_PLAN_ID) {
      onChangeCustomPlan({
        planAmount: quoteSelected.selectedPlanAmount,
        planId: quoteSelected.selectedPlan,
        planPackagedId: option.value,
      });
      return;
    }

    const newSelectedPlan = plansPackaged
      .find((plan) => plan.Id === option.value);
    onChangePrepackagedPlan(newSelectedPlan)({
      planAmount: newSelectedPlan.maxAnnual,
      planId: newSelectedPlan.PlanId,
      planPackagedId: newSelectedPlan.Id,
    });
  };

  /** If the manual selection matches some prepackaged,
    * shall select the matching option */
  useEffect(() => {
    if (quoteSelected.selectedPlanPackaged === CUSTOM_PLAN_ID
      && matchingPrepackagedPlan) {
      onChangePrepackagedPlan(matchingPrepackagedPlan)({
        planAmount: matchingPrepackagedPlan.maxAnnual,
        planId: matchingPrepackagedPlan.PlanId,
        planPackagedId: matchingPrepackagedPlan.Id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchingPrepackagedPlan]);

  return (
    <DropdownCommon
      label={t('prop103.filterBy')}
      onChange={onChange}
      options={options}
      tooltipText={t('prop103.filterByTooltip')}
      value={selectedOption}
    />
  );
};
